import {
  ReducedVesselReport,
  ReportStatuses,
  VesselReportsVm,
} from '@navstation-portal/reporting/data-model/vessel-reports';
import { getAllowedNextReportTypes } from '../../report-type-sequence/allowed-next-report-types';

export function buildVesselReportsVm(reports: ReducedVesselReport[]): VesselReportsVm {
  const sorted = [...reports].sort((a, b) => b.reportNumber - a.reportNumber);
  const lastCompletedReport = [...sorted].find((report) => report.status === ReportStatuses.Completed);
  const latestReport = sorted.length > 0 ? sorted[0] : undefined;
  const canCreateReport = !latestReport || latestReport.status === ReportStatuses.Completed;
  const allowedNextReportTypes = getAllowedNextReportTypes(lastCompletedReport?.reportType);
  const incompleteReportId = latestReport && latestReport.status !== ReportStatuses.Completed ? latestReport.id : null;

  return {
    reports: [...sorted],
    lastSubmittedReportType: lastCompletedReport?.reportType,
    canCreateReport,
    allowedNextReportTypes,
    incompleteReportId,
  };
}
